import { render, staticRenderFns } from "./accountPassword.vue?vue&type=template&id=f5a699be&scoped=true"
import script from "./accountPassword.vue?vue&type=script&lang=js"
export * from "./accountPassword.vue?vue&type=script&lang=js"
import style0 from "./accountPassword.vue?vue&type=style&index=0&id=f5a699be&prod&lang=less&scoped=true"
import style1 from "./accountPassword.vue?vue&type=style&index=1&id=f5a699be&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a699be",
  null
  
)

export default component.exports